import { MockFactory } from '@tino-frontend/mocks'
import { PaymentLinkDetail, PaymentLinkStatus } from '@types'
import { paymentLinkDetailBaseMock } from './payment-link-detail-base'

export const paymentLinkDetailPartialBilledMock =
  new MockFactory<PaymentLinkDetail>({
    ...paymentLinkDetailBaseMock.build(),
    status: PaymentLinkStatus.PartialBilled,
    limit_reservation_id: 'limit_reservation_id',
  })
